import { render } from "./politiqueConfidentialite.vue?vue&type=template&id=2f3b02d1"
import script from "./politiqueConfidentialite.vue?vue&type=script&lang=js"
export * from "./politiqueConfidentialite.vue?vue&type=script&lang=js"

import "./politiqueConfidentialite.vue?vue&type=style&index=0&id=2f3b02d1&lang=scss"

import exportComponent from "/Users/jeromebart/sites/cdm-quiz/cite-des-metiers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__